/**
 * Storybook note: `src/__mocks__/routes.ts` shadows this module inside
 * stories with a parallel tree of story-id paths, so
 * `navigate(routes.x.y)` lands on a sibling story rather than a real
 * route. When you add a new route here and want Storybook navigation
 * to it to work, add a matching leaf in the mock file pointing at
 * that page's story id.
 */

export const routes = {
  root: '/',
  public: {
    booking: '/booking',
    bookingCancel: '/booking/cancel',
    subscriptionRenewal: '/public/renew',
  },
  signIn: '/sign-in',
  account: {
    index: '/account',
    pets: {
      index: '/account/pets',
      add: '/account/pets/new',
      book: '/account/pets/:patientId/book',
      intake: '/account/pets/:patientId/intake',
      plan: '/account/pets/:patientId/plan',
      records: '/account/pets/:patientId/records',
      checkout: '/account/pets/:patientId/checkout',
      upgrade: '/account/pets/:patientId/upgrade',
      paymentFailed: '/account/pets/:patientId/checkout/payment-failed',
      welcome: '/account/pets/:patientId/welcome',
    },
    appointments: {
      reschedule: '/account/appointments/:appointmentId/reschedule',
    },
    billing: {
      index: '/account/billing',
      invoice: '/account/billing/invoices/:invoiceId',
    },
    orders: '/account/orders',
    profile: '/account/profile',
    phone: {
      verify: '/account/phone/verify',
      update: '/account/phone/update',
    },
    email: {
      verify: '/account/email/verify',
      update: '/account/email/update',
    },
  },
} as const
